const env = process.env.ENV;

class Configs {
  get ENV() {
    return env;
  }

  get BFF_BASE_URL(): string | undefined {
    if (env === 'stg' || env === 'prd' || this.MOCK_REQUESTS) return undefined;
    return 'https://xxxxxxx.com/v1';
  }

  get MOCK_REQUESTS() {
    return env === 'dev';
  }

  get CUB_WHATSAPP(): string | undefined {
    return '(11) 4200-6020';
  }

  get CUB_WHATSAPP_BASE_URL(): string | undefined {
    return 'https://api.whatsapp.com/send?phone=551142006020';
  }

  get CUB_MAIN_DOCUMENT(): string | undefined {
    return '45.405.205/0001-95';
  }

  get CUB_PRIVACY_POLICY_URL(): string | undefined {
    return 'https://www.cub.com.br/assets/termo_privacidade.pdf';
  }
}

export default new Configs();
